













import { Component, Vue } from "vue-property-decorator";
import CustomTable from "@/components/table.vue";
import HistoryApi from "@/api/admin/history";
import { HistoryModel, PaginationModel, WalletModel } from "@/api/types";

@Component({
  components: {
    CustomTable,
  },
})
export default class History extends Vue {
  data: HistoryModel[] = [];
  pagination: PaginationModel & { total?: number } = {
    current: 1,
    pageSize: 100,
    total: 0,
  };
  wallet: WalletModel = {};
  visible = false;
  modalLoading = false;

  datum: HistoryModel = {};

  columns = [
    {
      width: 200,
      title: "발생일",
      dataIndex: "createdTime",
      scopedSlots: { customRender: "createdTime" },
    },
    {
      width: 100,
      title: "이름",
      dataIndex: "name",
      scopedSlots: { customRender: "name" },
    },
    {
      width: 150,
      title: "연락처",
      dataIndex: "phone",
      scopedSlots: { customRender: "phone" },
    },
    {
      width: 200,
      title: "수량",
      dataIndex: "amount",
      scopedSlots: { customRender: "amount" },
    },
    {
      title: "내용",
      dataIndex: "description",
      scopedSlots: { customRender: "description" },
    },
    {
      title: "txID",
      dataIndex: "txId",
      scopedSlots: { customRender: "txId" },
    },
  ];

  moveOn(page: any) {
    this.pagination = page;
    this.load();
  }

  search() {
    this.load();
  }

  showModal() {
    this.visible = true;
  }

  rowClick(record: HistoryModel) {
    this.visible = true;
    this.datum = {
      ...record,
    };
  }

  async handleOk() {
    this.modalLoading = true;

    this.load();
    this.modalLoading = false;
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
  }

  mounted() {
    this.load();
  }

  async load() {
    localStorage.removeItem("auth");
    const result = await HistoryApi.total(this.pagination);

    this.data = [...result.data];
    this.pagination.total = result.totalCount;
  }
}
